export enum VoteType {
  Against = 0,
  For = 1,
  Abstain = 2,
}
